import type { DefaultTheme } from 'styled-components';

declare module 'styled-components' {
  export interface DefaultTheme {
    fontFamily: string;
    defaultFontFamily: string;
    palette: {
      primary: {
        main: string;
        dark: string;
        light: string;
      };
      secondary: {
        light: string;
      };
      background: {
        secondary: string;
        light: string;
        primary: string;
        primary80: string;
        disabled: string;
        purple20: string;
        purpleDarkened1: string;
        purpleDarkened3: string;
        pearl: string;
        pearl40: string;
        grey2: string;
        grey5: string;
        grey6: string;
      };
      text: {
        primary: string;
        primary60: string;
        primary80: string;
        secondary: string;
        light: string;
        purple40: string;
        purpleDarkened3: string;
        grey: string;
        attention: string;
        attention15: string;
      };
      icon: {
        purple: string;
        purple20: string;
        purple40: string;
        purple60: string;
      };
      border: string;
      green: string;
      error: string;
      warning: string;
      success: string;
      success15: string;
    };
  }
}

const theme: DefaultTheme = {
  fontFamily: 'Inter',
  defaultFontFamily:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", "Open Sans", "Source Sans Pro", sans-serif',
  palette: {
    primary: {
      main: '#9C43FF',
      dark: '#6B32B1',
      light: '#EBD9FF',
    },
    secondary: {
      light: '#d9e4e9',
    },
    background: {
      secondary: '#F4F4F3',
      light: '#ffffff',
      primary: '#e9fafb',
      primary80: '#ECECEB',
      disabled: '#f5f5f5',
      purple20: '#EBD9FF',
      purpleDarkened1: '#833BD8',
      purpleDarkened3: '#512B8B',
      pearl: '#ECECEB',
      pearl40: '#F7F7F7',
      grey2: '#D2D1D8',
      grey5: '#E0E0E0',
      grey6: '#F2F2F2',
    },
    text: {
      primary: '#201A3D',
      primary60: '#201A3D',
      primary80: '#4D4864',
      secondary: '#8c9aa7',
      light: '#ffffff',
      purple40: '#D7B4FF',
      purpleDarkened3: '#512B8B',
      grey: '#79768B',
      attention: '#d31e47',
      attention15: '#f9dde4',
    },
    icon: {
      purple: '#9C43FF',
      purple20: '#EBD9FF',
      purple40: '#D7B4FF',
      purple60: '#C48EFF',
    },
    border: '#A6A3B1',
    green: '#53c41a',
    error: '#ff4d4f',
    warning: '#FFA800',
    success: '#3ECB0C',
    success15: '#E2F7DB',
  },
};

type ThemeType = typeof theme;

export type { ThemeType };
export default theme;
